// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/canvaspuzzle/components/pieces/StartAnimation.css */

@keyframes flyToTray {
  0% {
    transform: translate(var(--start-x), var(--start-y)) rotate(var(--start-rotation));
    opacity: 1;
  }
  /* Промежуточный кадр для "разлета" */
  25% {
    transform: translate(var(--mid-x), var(--mid-y)) rotate(var(--mid-rotation));
    opacity: 1;
  }
  /* Конечная точк */
  100% {
    transform: translate(var(--end-x), var(--end-y)) rotate(var(--end-rotation));
    opacity: 1; 
  }
}

.animated-piece-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 490;
  pointer-events: none;
  /* Длительность анимации берется из JS константы */
  animation: flyToTray var(--animation-duration, 1.5s) ease-out forwards;
  will-change: transform, opacity, rotate; /* Подсказка браузеру */
}

/* Стили для самого PuzzlePiece внутри .animated-piece-container не нужны,
   если они не переопределяют что-то из PuzzlePiece.css */
`, "",{"version":3,"sources":["webpack://./src/components/canvaspuzzle/components/pieces/StartAnimation.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;EACE;IACE,kFAAkF;IAClF,UAAU;EACZ;EACA,qCAAqC;EACrC;IACE,4EAA4E;IAC5E,UAAU;EACZ;EACA,kBAAkB;EAClB;IACE,4EAA4E;IAC5E,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,oBAAoB;EACpB,kDAAkD;EAClD,sEAAsE;EACtE,uCAAuC,EAAE,uBAAuB;AAClE;;AAEA;yDACyD","sourcesContent":["/* src/components/canvaspuzzle/components/pieces/StartAnimation.css */\n\n@keyframes flyToTray {\n  0% {\n    transform: translate(var(--start-x), var(--start-y)) rotate(var(--start-rotation));\n    opacity: 1;\n  }\n  /* Промежуточный кадр для \"разлета\" */\n  25% {\n    transform: translate(var(--mid-x), var(--mid-y)) rotate(var(--mid-rotation));\n    opacity: 1;\n  }\n  /* Конечная точк */\n  100% {\n    transform: translate(var(--end-x), var(--end-y)) rotate(var(--end-rotation));\n    opacity: 1; \n  }\n}\n\n.animated-piece-container {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 490;\n  pointer-events: none;\n  /* Длительность анимации берется из JS константы */\n  animation: flyToTray var(--animation-duration, 1.5s) ease-out forwards;\n  will-change: transform, opacity, rotate; /* Подсказка браузеру */\n}\n\n/* Стили для самого PuzzlePiece внутри .animated-piece-container не нужны,\n   если они не переопределяют что-то из PuzzlePiece.css */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
